import { ref, readonly } from 'vue';
const state = ref('idle');
export const walletRecoveryState = readonly(state);
export const setWalletRecoveryState = value => { state.value = value; };
// One lifecycle subscription per mounted App; callers own cleanup.
export function bindWalletRecovery(recover) {
  let scheduled = false, disposed = false;
  const run = () => {
    if (disposed || document.visibilityState === 'hidden' || scheduled) return;
    scheduled = true;
    Promise.resolve().then(() => disposed ? undefined : recover()).catch(() => {}).finally(() => { scheduled = false; });
  };
  const events = ['pageshow', 'focus', 'ethereum#initialized', 'eip6963:announceProvider'];
  for (const event of events) window.addEventListener(event, run);
  document.addEventListener('visibilitychange', run);
  return () => {
    disposed = true;
    for (const event of events) window.removeEventListener(event, run);
    document.removeEventListener('visibilitychange', run);
  };
}
